import React from 'react';
import { useTranslation } from 'react-i18next';

const StatCard = ({ label, value, valueClass = 'text-gray-900', star = false, testId }) => (
  <div className="bg-white p-3 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-100" data-testid={testId}>
    <h3 className="text-gray-500 text-xs sm:text-sm font-medium leading-tight">{label}</h3>
    <p className={`text-xl sm:text-3xl font-bold mt-1 sm:mt-2 flex items-center gap-1 sm:gap-2 ${valueClass}`}>
      {value}
      {star && (
        <svg className="w-4 h-4 sm:w-6 sm:h-6 text-yellow-500 fill-yellow-500 shrink-0" viewBox="0 0 20 20">
          <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
        </svg>
      )}
    </p>
  </div>
);

const DashboardStats = ({ stats, effectiveRole }) => {
  const { t } = useTranslation();
  if (!stats) return null;

  const isProvider = effectiveRole === 'provider';
  // Mobile: everything on one row (4 cols for provider, 3 for client). Desktop keeps the same neat grid.
  const gridCols = isProvider ? 'grid-cols-4' : 'grid-cols-3';

  return (
    <div className={`grid ${gridCols} gap-2 sm:gap-4 mb-8`} data-testid="dashboard-stats">
      {isProvider ? (
        <>
          <StatCard testId="stat-services" label={t('dashboard.statMyServices')} value={stats.services} />
          <StatCard testId="stat-bookings" label={t('dashboard.statTotalBookings')} value={stats.bookings} />
          <StatCard testId="stat-pending" label={t('dashboard.statPendingRequests')} value={stats.pending_bookings} valueClass="text-amber-600" />
          <StatCard
            testId="stat-rating"
            label={t('dashboard.statRating')}
            value={stats.rating > 0 ? stats.rating : t('dashboard.na')}
            star={stats.rating > 0}
          />
        </>
      ) : (
        <>
          <StatCard testId="stat-jobs" label={t('dashboard.statMyJobs')} value={stats.jobs} />
          <StatCard testId="stat-bookings" label={t('dashboard.statTotalBookings')} value={stats.bookings} />
          <StatCard testId="stat-active" label={t('dashboard.statActiveBookings')} value={stats.active_bookings} valueClass="text-green-600" />
        </>
      )}
    </div>
  );
};

export default DashboardStats;
